import { render, staticRenderFns } from "./personage.vue?vue&type=template&id=1ca7e04e&scoped=true&"
import script from "./personage.vue?vue&type=script&lang=js&"
export * from "./personage.vue?vue&type=script&lang=js&"
import style0 from "./personage.vue?vue&type=style&index=0&id=1ca7e04e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca7e04e",
  null
  
)

export default component.exports